export enum SidebarActions {
  SET_SIDEBAR_LOCKED = 'SET_SIDEBAR_LOCKED',
  SET_SIDEBAR_ACTIVE_TAB = 'SET_SIDEBAR_ACTIVE_TAB',
  SET_INITIAL_SIDEBAR_STATE = 'SET_INITIAL_SIDEBAR_STATE',
  SET_SIDEBAR_WIDTH = 'SET_SIDEBAR_WIDTH',
}
